import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { onboardingGuard } from './core/guards/onboarding.guard';
import { permissionGuard } from './core/guards/permission.guard';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./landing/inclub-academy-landing').then((m) => m.InclubAcademyLanding),
    pathMatch: 'full'
  },

  {
    path: 'login',
    redirectTo: 'auth/login',
    pathMatch: 'full',
  },

  {
    path: 'auth',
    loadChildren: () => import('./features/auth/routes').then((m) => m.authRoutes),
  },

  {
    path: 'onboarding',
    loadComponent: () =>
      import('./onboarding/onboarding.component').then((m) => m.OnboardingComponent),
    canActivate: [onboardingGuard],
  },

  {
    path: 'enrollments',
    canActivate: [authGuard],
    loadChildren: () =>
      import('./features/enrollments/enrollments.routes').then((m) => m.enrollmentRoutes),
  },


  {
    path: '',
    loadComponent: () => import('./layout/main-layout/main-layout').then((m) => m.MainLayout),
    canActivate: [authGuard],
    children: [
      {
        path: 'dashboard',
        loadChildren: () =>
          import('./features/dashboard/dashboard.routes').then((m) => m.dashboardRoutes),
      },
      // {
      //   path: 'users',
      //   loadChildren: () =>
      //     import('./features/user-management/user-management.routes').then(
      //       (m) => m.userManagementRoutes,
      //     ),
      // },
      {
        path: 'content',
        loadChildren: () =>
          import('./features/content/content.routes').then(
            (m) => m.contentRoutes,
          ),
      },
      {
        path: 'courses',
        canActivate: [permissionGuard('COURSE_VIEW')],
        loadChildren: () =>
          import('./features/course-management/course-management.routes').then(
            (m) => m.courseManagementRoutes,
          ),
      },
      {
        path: 'events',
        canActivate: [permissionGuard('EVENT_VIEW')],
        loadChildren: () => import('./features/events/events.routes').then((m) => m.eventsRoutes),
      },

      {
        path: 'tutorials',
        loadChildren: () =>
          import('./features/tutorials/tutorials.routes').then((m) => m.tutorialsRoutes),
      },
      {
        path: 'certificates',
        loadChildren: () =>
          import('./features/certificates/certificates.routes').then((m) => m.certificatesRoutes),
      },
    ],
  },

  { path: '**', redirectTo: 'dashboard' },
];
